import React from 'react';
import { Outlet } from 'react-router-dom';
import { SideBarComponent } from '@components';
import { StyledContainer, StyledContainerWrapper, StyledMain, StyledPrivateWrapper } from './private-layout.styles';
/**
 * Page hoc component.
 *
 * @author Mikhail Siutsou
 * @function PrivateLayout
 * @category Hocs
 * @return {JSX.Element} wrapped component.
 */

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var PrivateLayout = function PrivateLayout(_ref) {
  var inline = _ref.inline;
  return /*#__PURE__*/_jsxs(StyledPrivateWrapper, {
    children: [/*#__PURE__*/_jsx(SideBarComponent, {}), /*#__PURE__*/_jsx(StyledMain, {
      component: "main",
      children: /*#__PURE__*/_jsx(StyledContainerWrapper, {
        children: inline ? /*#__PURE__*/_jsx(Outlet, {}) : /*#__PURE__*/_jsx(StyledContainer, {
          children: /*#__PURE__*/_jsx(Outlet, {})
        })
      })
    })]
  });
};

export { PrivateLayout };